import {Adresse} from './adresse';
import {deserialize, deserializeAs, inheritSerialization} from 'cerialize';
import {Entity} from './entity';
import {User} from "./user";
import {Document} from "./document";
import {Construction} from "./construction";
import {Dpe} from "./dpe";
import {Zone} from "./zone";
import {Nuisance} from "./nuisance";
import {Copropriete} from "./copropriete";

@inheritSerialization(Entity)
export class Residence extends Entity {
  @deserialize
  nom: string;
  @deserializeAs(Adresse)
  adresse: Adresse;
  @deserializeAs(User, 'bailleur_full_residence')
  bailleurFullResidence: User[] = [];
  @deserializeAs(Construction, 'construction')
  construction;
  @deserializeAs(Dpe, 'dpe')
  dpe;
  @deserializeAs(Zone, 'zone')
  zone;
  @deserializeAs(Nuisance, 'nuisance')
  nuisance;
  @deserializeAs('nom_maitre_oeuvre')
  nomMaitreOeuvre;
  @deserializeAs('parcelle_cadastrale')
  parcelleCadastrale;
  @deserializeAs('appartenance_terrain_lotissement')
  appartenanceTerrainLotissement;
  @deserializeAs('point_livraison_enedis')
  pointLivraisonEnedis;
  @deserializeAs('point_comptage')
  pointComptage;
  @deserializeAs(Copropriete, 'copropriete')
  copropriete;
  @deserializeAs('numero_immatriculation_copropriete')
  numeroImmatriculationCopropriete;
  @deserializeAs('certification_nf')
  certificationNF;
  @deserializeAs('numero_certification_nf')
  numeroCertificationNF: string;
}
